import React, { lazy, Suspense } from 'react';
import { FiltersContextProvider } from './Search/Filters/ContextProvider';

const MapSearch = lazy(() => import('./index.lazy'));

const renderLoader = () => <p>Loading</p>;

const MapSearchSuspense = () => (
  <Suspense fallback={renderLoader()}>
    <FiltersContextProvider>
      <MapSearch />
    </FiltersContextProvider>
  </Suspense>
);

export default MapSearchSuspense;
